
<template>
    <div class="d-flex align-center justify-center" style="height: 100vh">
        <v-sheet width="400" class="mx-auto">
            <v-form fast-fail @submit.prevent="login">
                <v-text-field 
                    v-model="user_id" 
                    label="UserId"
                    :rules="[rules.required]"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-icon="passwordshow ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="passwordshow ? 'text' : 'password'"
                    name="input-10-1"
                    label="Normal with hint text"
                    hint="At least 4 characters"
                    counter
                    @click:append="passwordshow = !passwordshow"
                ></v-text-field>
                <a href="#" class="text-body-2 font-weight-regular">Forgot Password?</a>

                <v-btn type="submit" color="primary" block class="mt-2">Sign in</v-btn>

            </v-form>
            <div class="mt-2">
                <p class="text-body-2">Don't have an account? <a href="#">Sign Up</a></p>
            </div>
        </v-sheet>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            user_id: '',
            password: '',
            passwordshow: false,
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 4 || 'Min 4 characters',
                emailMatch: () => (`The email and password you entered don't match`),
            },
        };
    },
    methods: {
        login() {
            axios.post(process.env.VUE_APP_API_URL + '/api/login', {
                user_id: this.user_id,
                password: this.password
            })
            .then( res => {
                console.log(res)
                this.$store.dispatch('saveToken', res.data) // 小文字にします
                // ホームに戻す
                this.$router.push('/user')
            })
            .catch( e => {
                alert("ログインに失敗しました")
                console.log(e)
            })
        },
    },
}
</script>